import { useEffect, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UILoadingSpinnerCentered from 'automation-ui-formula-editor/components/common/UILoadingSpinnerCentered';
import DataPassingPanelHeaderSearchProperties from 'automation-ui-formula-editor/data-passing-panel/DataPanelRevisedUXMode/DataPassingPanelHeaderSearchProperties';
import DataPassingPanelHeaderSelectDataSource from 'automation-ui-formula-editor/data-passing-panel/DataPanelRevisedUXMode/DataPassingPanelHeaderSelectDataSource';
import DataPassingPanelHeaderEditAvailableButton from 'automation-ui-formula-editor/data-passing-panel/DataPanelRevisedUXMode/DataPassingPanelHeaderEditAvailableButton';
import { ENROLLED_OBJECT } from 'automation-ui-formula-editor/data-sources/constants/dataSourcesConstants';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { FirstIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const DataPassingPanelHeader = ({
  flowObjectTypeId,
  isAddDataSourceBtnVisible,
  isEmbedded,
  isFirstAction,
  lastDeletedDataSource,
  lastAddedEditedDataSource,
  onChangeSelectedDataSource,
  onClosePanelClick,
  onDataSourceSearch,
  openFetchObjectPanel,
  searchFilterString,
  dataSource,
  selectedDataSourcePrefix = ENROLLED_OBJECT,
  dataSourceAllowList
}) => {
  const [shouldRenderDataSourceSelect, setShouldRenderDataSourceSelect] = useState(true);
  useEffect(() => {
    if (!lastDeletedDataSource) {
      return;
    }
    setShouldRenderDataSourceSelect(false);
    // DEV NOTE: Force a full unmount / remount by updating state to unmount the data source
    // select. Then one frame later mount the data source select component. This facilitates
    // deleting a data source and having the data source select component pick up the changes
    requestAnimationFrame(() => setShouldRenderDataSourceSelect(true));
  }, [lastDeletedDataSource]);
  const FormLabel = () => {
    return /*#__PURE__*/_jsxs(Flex, {
      paddingBlockEnd: "300",
      justifyContent: "space-between",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h5",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-formula-editor.data-passing-panel.panel-header.label"
        })
      }), /*#__PURE__*/_jsx(IconButton, {
        size: "xs",
        use: "unstyled",
        "data-test-id": "data-panel-collapse-button",
        onClick: onClosePanelClick,
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-formula-editor.data-passing-panel.panel-collapse.tooltip"
        }),
        color: "fill-accent-blue-default",
        marginInlineEnd: "-100",
        children: /*#__PURE__*/_jsx(FirstIcon, {})
      })]
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIFormControl, {
      label: FormLabel(),
      help: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.data-passing-panel.panel-header.help"
      }),
      className: "m-bottom-2 p-top-1",
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [shouldRenderDataSourceSelect ? /*#__PURE__*/_jsx(DataPassingPanelHeaderSelectDataSource, {
          selectedDataSourcePrefix: selectedDataSourcePrefix,
          onChangeSelectedDataSource: onChangeSelectedDataSource,
          isAddDataSourceBtnVisible: isAddDataSourceBtnVisible,
          isEmbedded: isEmbedded,
          isFirstAction: isFirstAction,
          openFetchObjectPanel: openFetchObjectPanel,
          lastAddedEditedDataSource: lastAddedEditedDataSource,
          lastDeletedDataSource: lastDeletedDataSource,
          dataSourceAllowList: dataSourceAllowList
        }) : /*#__PURE__*/_jsx(UILoadingSpinnerCentered, {}), /*#__PURE__*/_jsx(DataPassingPanelHeaderSearchProperties, {
          flowObjectTypeId: flowObjectTypeId,
          dataSource: dataSource,
          onDataSourceSearch: onDataSourceSearch,
          searchFilterString: searchFilterString
        })]
      })
    }), isAddDataSourceBtnVisible && /*#__PURE__*/_jsx(DataPassingPanelHeaderEditAvailableButton, {
      openFetchObjectPanel: openFetchObjectPanel
    })]
  });
};
export default DataPassingPanelHeader;